import { makeApp } from './app'
import { createAxiosInstance } from './utils/axios.js'

const { app, router, store} = makeApp('', window.location.href)
app.config.globalProperties.$fetchFn = createAxiosInstance()
if (window.__INITIAL_STATE__) {
  console.log('window.__INITIAL_STATE__', window.__INITIAL_STATE__)
  store.state.value = window.__INITIAL_STATE__
}
router.push(window.location.pathname + window.location.search + window.location.hash)

router.isReady().then(() => {
  app.mount('#app', true)
})